/* eslint-disable no-param-reassign */
import './scss/car-specs-compare-detail.scss';
import './scss/car-specs-compare-accordion.scss';

import CarSpecsCompareAccordion from './car-specs-compare-accordion';
import Carousel from './carousel';
import EmissionGraph from '../../emission_graph';
import Equalizer from '../../utils/equalizer';
import AnalyticsHelper from '../../utils/analytics-helper';

export default class CarSpecsCompare {
    constructor(el) {
        this.el = el;
        this.accordion = new CarSpecsCompareAccordion(this.el);
        this.configuratorLinks = el.querySelectorAll('.configurator-link');
        this.carousel = new Carousel(this, el.querySelector('.swiper'));
        Equalizer.equalizeItems(this.el.querySelectorAll('.description'));
        Equalizer.equalizeItems(this.el.querySelectorAll('.compare-car-detail'));
        Equalizer.equalizeItems(this.el.querySelectorAll('.compare-car-detail .compare-car-detail-inner'));
        Equalizer.equalizeItems(this.el.querySelectorAll('.compare-car-detail .car-title'));
        Equalizer.equalizeItems(this.el.querySelectorAll('.compare-car-detail .car-image'));
        Equalizer.equalizeItems(this.el.querySelectorAll('.compare-car-detail .car-detail'));
        Equalizer.equalizeItems(this.el.querySelectorAll('.compare-car-detail .promotional-price'));
        Equalizer.equalizeItems(this.el.querySelectorAll('.compare-car-detail .configure-btn'));
        Equalizer.equalizeItems(this.el.querySelectorAll('.compare-car-detail .spec-cta-group'));
        Equalizer.equalizeItems(this.el.querySelectorAll('.compare-car-detail .car-discription'));
        Equalizer.equalizeItems(this.el.querySelectorAll('.compare-car-detail .car-detail-description'));

        this.renderEmissionGraph();
        this.preselectConfigurator();
        this.accordion.showAll();
    }

    preselectConfigurator() {
        this.configuratorLinks.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const data = { grade: el.dataset.gradeCode, engine: el.dataset.engineCode };
                localStorage.setItem('car-configurator-preselect', JSON.stringify(data));
                AnalyticsHelper.push(el, el.href);
            });
        });
    }

    renderEmissionGraph() {
        const emissionContainers = this.el.querySelectorAll('.dynamicEmissionWrapper');

        emissionContainers.forEach((item, index) => {
            item.style.display = 'block';
            const data = JSON.parse(item.dataset.emissions);
            const graphWrapper = item.querySelector('.graph');
            const disclaimerWrapper = item.querySelector('.details');
            const emissionInstance = new EmissionGraph(graphWrapper, disclaimerWrapper, data, { prefixString: `${index + 1}-` });
            emissionInstance.update();
        });
    }
}
